import { tinyCfg } from './config';

$(document).ready(function () {

    var kbwComments = (function () {

        var $window = $(window);

        let ajaxEndpoint = '/kbw/comment/';
        let useTiny = true;

        let tinyConfig = tinyCfg;

        // let tinyConfig = {
        //     menubar: false,
        //     paste_as_text: true,
        //     plugins: [
        //         'advlist autolink lists link image charmap print preview anchor',
        //         'searchreplace visualblocks code fullscreen',
        //         'insertdatetime media table paste code help wordcount'
        //     ],
        //     toolbar: 'undo redo | formatselect | ' +
        //         'bold italic underline strikethrough backcolor | bullist numlist | ' +
        //         'code removeformat',
        //     content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
        // }

        var init = function () {

            // for test purposes

            // console.log('project init');
            //
            // let data = {};
            //
            // $.ajax({
            //     method: "POST",
            //     url: '/kbw/user/test',
            //     data: data,
            //     dataType: "json"
            //
            // }).done(function (returnData) {
            //     //console.log(returnData['output']);
            //     // if (returnData['success']) {
            //     //     console.log(returnData['numDocs']);
            //     // }
            //
            //     console.log(returnData['output']);
            //
            // }).fail(function (jqXHR, textStatus) {
            //     console.log(textStatus);
            // });
            if (useTiny) {
                tinymce.init({
                    ...{selector: '.js-comment-new-text'}, ...tinyConfig
                });

                // tinymce.init({
                //     selector: '.js-comment-editor-text'
                // });
            }

            addEventListeners();
            return;
        };

        var addEventListeners = function () {

            $('.js-save-new-comment').on('click', handleSaveNewComment);

            $('.js-comment-container').on('click', '.js-edit-comment', handleEditComment);
            $('.js-comment-container').on('click', '.js-delete-comment', handleDeleteComment);
            $('.js-comment-container').on('click', '.js-save-comment', handleSaveComment);
            $('.js-comment-container').on('click', '.js-cancel-comment', handleCancelComment);

        }

        var handleEditComment = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $comment = $target.parents('.js-comment-item');

            if (!$comment.hasClass('js-comment-item--active')) {
                $comment.addClass('js-comment-item--active');

                let actText = $comment.find('.js-comment-act-text').html().trim();
                let editorId = $comment.find('.js-comment-editor-text').attr('id');
                $comment.find('.js-comment-editor-text').val(actText);

                if (useTiny) {
                    tinymce.init({
                        ...{selector: '#' + editorId}, ...tinyConfig
                    });
                }

            }
        }

        var handleDeleteComment = function (event) {
            event.preventDefault();

            if (!confirm('Wollen Sie diesen Kommentar wirklich löschen?')) {
                return;
            }

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-comment-item');
            let cid = $target.data('cid');

            let url = ajaxEndpoint + 'remove';
            let data = {
                commentId: cid
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, removeComment);
        }

        var handleSaveComment = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $target.parents('.js-comment-item');
            let $form = $target.parents('.js-edit-form-comment');
            let cid = $form.find('input[name="cid"]').val();

            let text = '';
            if (useTiny) {
                let editorId = $form.find('.js-comment-editor-text').attr('id');
                text = tinymce.get(editorId).getContent();
            } else {
                text = $form.find('.js-comment-editor-text').val();
            }

            if (text.trim() === '') {
                return;
            }

            let url = ajaxEndpoint + 'edit';
            let data = {
                commentId: cid,
                text: text
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, updateComment);
        }

        var handleCancelComment = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $comment = $target.parents('.js-comment-item');

            $comment.removeClass('js-comment-item--active');
        }

        var handleSaveNewComment = function (event) {
            event.preventDefault();

            let $target = $(event.currentTarget);
            let $container = $('.js-comment-container');

            let $form = $target.parents('.js-comment-form');
            let aid = $form.find('input[name="aid"]').val();
            let ts = $form.find('input[name="ts"]').val();

            let text = '';
            if (useTiny) {
                text = tinymce.get('new_comment').getContent();
            } else {
                text = $form.find('.js-comment-new-text').val();
            }


            console.log(text);

            let url = ajaxEndpoint + 'new';
            let data = {
                applicationId: aid,
                timestamp: ts,
                text: text
            }

            // console.log(data);

            ajaxPost(url, data, $container, $target, addNewComment);

        }

        var addNewComment = function ($container, $target, data) {
            // console.log('add new comment');
            // console.log(data['htmlOutput']);
            $container.append(data['htmlOutput']);

            let $form = $target.parents('.js-comment-form');
            console.log('ts' + data['ts']);
            $form.find('input[name="ts"]').val(data['ts']);


            clearForm();
        }

        var clearForm = function () {
            $('.js-comment-new-text').val('');
            if (useTiny) {
                let text = tinymce.get('new_comment').setContent('');
            }
        }

        var updateComment = function ($container, $target, data) {
            console.log('update');
            console.log(data['htmlOutput']);

            $container.find('.js-comment-act-text').html(data['htmlOutput']);
            $container.find('.js-comment-ts-update').html(', geändert: ' + data['timestampUpdate']);
            $container.removeClass('js-comment-item--active');
        }

        var removeComment = function ($container, $target, data) {
            console.log('remove');

            $container.remove();
        }

        // var handleNewMultirow = function(event) {
        //     event.preventDefault();
        //
        //     let $target = $(event.currentTarget);
        //
        //     let fieldName = $target.data('multirow');
        //     let rowCounter = $target.data('multirow-max');
        //
        //     let data = {
        //         fieldName: fieldName,
        //         rowCounter: rowCounter
        //     }
        //
        //     console.log(fieldName + rowCounter);
        //
        //     let $container = $('#multirow_' + fieldName);
        //     // let url = '/kbw/multirow/' + fieldName;
        //     let url = '/kbw/multirow/add';
        //
        //     ajaxPost(url, data, $container, $target, addMultirow);
        // }
        //
        // var handleRemoveMultirow = function(event) {
        //     event.preventDefault();
        //
        //     let $target = $(event.currentTarget);
        //     let rowId = $target.data('multirow');
        //
        //     $('#multirow_' + rowId).remove();
        // }
        //

        var ajaxPost = function (url, data, $container, $target, successCallback) {
            $.ajax({
                method: "POST",
                url: url,
                data: data,
                dataType: "json"

            }).done(function (returnData) {
                console.log(returnData);
                // if (returnData['success']) {
                //     console.log(returnData['numDocs']);
                // }

                if (returnData['success'] === '1') {
                    successCallback($container, $target, returnData);
                } else {
                    alert(returnData['errMessage'])
                }

            }).fail(function (jqXHR, textStatus) {
                console.log(textStatus);
            });
        }


        return {
            init: init
        }

    })();

    kbwComments.init();

});



